<template>
  <div>
    <div class='expert-list'>
      <swiper  :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in 5" :key="item">
          <img class="pic" src="/images/goods/pkg16.png" alt="">
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        roundLengths: true,
        effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          autoplay:4000,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows : true
          },
      },
      
      list: []
    };
  }
};
</script>
<style scoped>
.expert-list{
  padding:10px 0 20px;
  background: #fff8f0;
}
.pic{
  display: block;
  width: 200px;
  height: 240px;
  box-shadow:0px 2px 10px rgba(0,0,0,0.1);
}
.expert-list .swiper-container {
  width: 375px;
  margin: auto
}
.swiper-slide{
  width: 200px
}
</style>